// Importando os nodes personalizados
import { InicioNode } from '~/components/CustomNodes/InicioNode';
import { FimNode } from '~/components/CustomNodes/FimNode';
import { EsperarNode } from '~/components/CustomNodes/EsperarNode';
import { DecidirNode } from '~/components/CustomNodes/DecidirNode';
import { MostrarNode } from '~/components/CustomNodes/MostrarNode';
import { InteragirAvatarNode } from '~/components/CustomNodes/InteragirAvatarNode';
import { LerNode } from '~/components/CustomNodes/LerNode';
import { OperatorEqualNode } from '~/components/CustomNodes/OperatorEqualNode';
import { OperatorNotEqualNode } from '~/components/CustomNodes/OperatorNotEqualNode';
import { OperatorGreaterNode } from '~/components/CustomNodes/OperatorGreaterNode';
import { OperatorLessNode } from '~/components/CustomNodes/OperatorLessNode';
import { OperatorGreaterEqualNode } from '~/components/CustomNodes/OperatorGreaterEqualNode';
import { OperatorLessEqualNode } from '~/components/CustomNodes/OperatorLessEqualNode';
import { OperatorSumNode } from '~/components/CustomNodes/OperatorSumNode';
import { OperatorSubtractNode } from '~/components/CustomNodes/OperatorSubtractNode';
import { OperatorMultiplyNode } from '~/components/CustomNodes/OperatorMultiplyNode';
import { OperatorDivideNode } from '~/components/CustomNodes/OperatorDivideNode';
import { OperatorPowerNode } from '~/components/CustomNodes/OperatorPowerNode';
import { OperatorRadicalNode } from '~/components/CustomNodes/OperatorRadicalNode';
import { OperatorAndNode } from '~/components/CustomNodes/OperatorAndNode';
import { OperatorOrNode } from '~/components/CustomNodes/OperatorOrNode';
import { OperatorNotNode } from '~/components/CustomNodes/OperatorNotNode';
import { OperatorXorNode } from '~/components/CustomNodes/OperatorXorNode';
import { AtribuirNode } from '~/components/CustomNodes/AtribuirNode';
import { AvatarVisivelNode } from '~/components/CustomNodes/AvatarVisivelNode';
import { AvatarPosicionarNode } from '~/components/CustomNodes/AvatarPosicionarNode';
import { AvatarVirarNode } from '~/components/CustomNodes/AvatarVirarNode';
import { FluxogramaNode } from '~/components/CustomNodes/FluxogramaNode';
import { RepetirNode } from '~/components/CustomNodes/RepetirNode';
import { FundoNode } from '~/components/CustomNodes/FundoNode';

// Styles
import '~/styles/CustomNodes.css';

// Exportando os nodes personalizados
export const nodeTypes = {
    Inicio: InicioNode,
    Fim: FimNode,
    Esperar: EsperarNode,
    Decidir: DecidirNode,
    Mostrar: MostrarNode,
    "Interagir Avatar": InteragirAvatarNode,
    Ler: LerNode,
    Atribuir: AtribuirNode,
    Fundo: FundoNode,
    "Visível": AvatarVisivelNode,
    "Posicionar": AvatarPosicionarNode,
    "Virar": AvatarVirarNode,
    "Fluxograma": FluxogramaNode,
    "Repetir": RepetirNode
};

export const SubNodes = {
    Soma: OperatorSumNode,
    "Subtração": OperatorSubtractNode,
    "Multiplicação": OperatorMultiplyNode,
    "Divisão": OperatorDivideNode,
    "Potenciação": OperatorPowerNode,
    "Radiciação": OperatorRadicalNode,
    "Igual a": OperatorEqualNode,
    "Diferente de": OperatorNotEqualNode,
    "Diferente": OperatorNotEqualNode,
    "Maior que": OperatorGreaterNode,
    "Menor que": OperatorLessNode,
    "Maior ou igual": OperatorGreaterEqualNode,
    "Maior ou igual a": OperatorGreaterEqualNode,
    "Menor ou igual": OperatorLessEqualNode,
    "Menor ou igual a": OperatorLessEqualNode,
    "Conjunção/Interseção": OperatorAndNode,
    "Disjunção inclusiva/União": OperatorOrNode,
    "Negação/complementação": OperatorNotNode,
    "Disjunção exclusiva": OperatorXorNode
};